// MARK: NPM Modules
import React from "react";
import styled from "styled-components";
// MARK: Redux
import { RootState } from "reduxFunctionality/index";
import { useSelector } from "react-redux";
// MARK: Types
import ReduxStyleguide from "types/redux/styleguide";
import MultilineHeadlineType from "types/fields/matrix/common/multilineHeadline";
// MARK: Components
import CSSTypography from ".";
import CSSStyles from "enums/cssStyles";
// MARK: Styled Components
interface ContainerProps {}

const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
`;

// MARK: React Component
// Props
interface Props {
  headlines: MultilineHeadlineType;
}
// Styleguide & Datapoints
const getDatapoints = (styleguide: ReduxStyleguide) => {
  const { colors } = styleguide;

  const { primary, secondary, tertiary } = colors;
  return {
    style: CSSStyles.large,
    primary: primary,
    secondary: secondary,
    tertiary: tertiary,
  };
};
// Component
const MultilineHeadline = ({ headlines }: Props) => {
  // MARK: React Redux Variables
  const styleguide: ReduxStyleguide = useSelector(
    (state: RootState) => state.styleguide
  );
  // MARK: Variables
  const { mobile } = styleguide;
  const { style, primary, secondary, tertiary } = getDatapoints(styleguide);
  // MARK: Functionality
  const renderHeadlines = () => {
    var spans: Array<any> = [];
    headlines.forEach((headline, index) => {
      var color = primary;
      if (mobile) {
        switch (index) {
          case 1:
            color = secondary;
            break;
          case 2:
            color = tertiary;
            break;
          default:
            break;
        }
      }

      spans.push(
        <CSSTypography
          key={headline.headline}
          type={"span"}
          className={style}
          color={color}
          textAlign={"left"}
        >
          {headline.headline} {index < headlines.length - 1 ? " " : ""}
        </CSSTypography>
      );
    });

    return spans;
  };

  // MARK: Render
  return (
    <Container>
      <CSSTypography type={"h1"} className={style} color={primary} textAlign={"left"}>
        {renderHeadlines()}
      </CSSTypography>
    </Container>
  );
};

export default MultilineHeadline;
